// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ogjrqjtvhfhwwqhlrmrx.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9nanJxanR2aGZod3dxaGxybXJ4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc3NjI0MjgsImV4cCI6MjA2MzMzODQyOH0.xo-HsRql1iZu-mphAWKcvIUaDEZNSECVpGJ1zBoeReY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);